import { ChevronDownIcon } from '../Icon/ChevronDownIcon';
import { useCollapse } from '~/hooks/useCollapse';
import styles from './CollapseCard.module.css';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  title: string;
  isOpen?: boolean;
  disabled?: boolean;
};

export function CollapseCard({ children, title, isOpen = false, disabled = false }: Props) {
  const collapse = useCollapse({ initialValue: isOpen });

  return (
    <div className={styles.collapseCard}>
      <button
        data-open={collapse.isOpen ? 'true' : 'false'}
        className={styles.toggler}
        onClick={collapse.toggle}
        type="button"
        disabled={disabled}
      >
        <h4>{title}</h4>
        <ChevronDownIcon />
      </button>

      {collapse.isOpen && <div className={styles.content}>{children}</div>}
    </div>
  );
}
